import React from 'react';
import { KeyRound, Loader2 } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { OtpInfoCard } from './AddStaffDialog';

/**
 * Reset-staff-password dialog. Parent owns state + the submit handler; the
 * dialog visibility is driven by `target` (truthy → open).
 */
export function ResetPasswordDialog({
  target, onClose,
  newPw, setNewPw,
  emailOtp, setEmailOtp,
  waOtp, setWaOtp,
  otpInfo,
  submitting,
  onSubmit,
}) {
  return (
    <Dialog open={!!target} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="team-reset-dialog" className="bg-slate-900 border-slate-800 text-slate-100 max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <KeyRound className="w-4 h-4 text-amber-400" /> Reset staff password
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Resetting <span className="text-slate-200">{target?.email}</span>. They&apos;ll be required to change it on next login.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3">
          <OtpInfoCard info={otpInfo} />
          <Input
            type="password"
            placeholder="New password (≥8 chars)"
            value={newPw}
            onChange={(e) => setNewPw(e.target.value)}
            data-testid="team-reset-new-pw"
            className="bg-slate-800/50 border-slate-700 text-white"
          />
          <Input
            placeholder="Email OTP (6 digits)"
            value={emailOtp}
            onChange={(e) => setEmailOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
            data-testid="team-reset-email-otp"
            className="bg-slate-800/50 border-slate-700 text-white font-mono tracking-widest text-center"
          />
          <Input
            placeholder="WhatsApp OTP (6 digits)"
            value={waOtp}
            onChange={(e) => setWaOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
            data-testid="team-reset-wa-otp"
            className="bg-slate-800/50 border-slate-700 text-white font-mono tracking-widest text-center"
          />
        </div>

        <DialogFooter>
          <Button onClick={onClose} variant="outline" className="border-slate-700 bg-slate-900 text-slate-200 hover:bg-slate-800">Cancel</Button>
          <Button onClick={onSubmit} disabled={submitting} data-testid="team-reset-submit" className="bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold">
            {submitting && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Confirm reset
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ResetPasswordDialog;
